<template>
  <div class="md-layout md-alignment-center home" :class="{ 'logged-out': !isLoggedIn }">
    <md-card class="md-layout-item md-elevation-3 md-size-50 md-small-size-100">
      <md-card-media>
        <img src="../assets/questionnaire.png" alt="Questionnaire image">
      </md-card-media>
      <md-card-header>
        <md-card-header-text>
          <div class="md-title">WageIndicator QuestAnalyzer</div>
        </md-card-header-text>
      </md-card-header>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <p>
              Provides a basic insight in the amount of surveys submitted in a certain period.
            </p>
            <p>
              The Questanalyzer counts questionnaires of type
              <a target="_blank" href="https://wsapp.wageindicator.org/main/en_GB">Websurvey</a>,
              <a target="_blank" href="https://scapp.wageindicator.org/#/en_GB/">Salary Check</a>,
              <a target="_blank" href="https://wsapp.wageindicator.org/f2f/en_GB">Face To Face</a>,
              <a target="_blank" href="https://wsapp.wageindicator.org/dwc/en_GB">Decent Work Check</a>,
              <a target="_blank" href="https://wsapp.wageindicator.org/gig/en_GB">Gig Survey</a>,
              <a target="_blank" href="https://wsapp.wageindicator.org/ets/en_GB">Event Tracking Survey</a>,
              <a target="_blank" href="https://wsapp.wageindicator.org/corona/en_GB">Corona Survey</a> and
              <a target="_blank" href="https://wsapp.wageindicator.org/corfact/en_GB">Corona Factory Survey</a>.
            </p>
            <p v-if="isLoggedIn">
              Further details and documentation can be found on the
              <a target="_blank" href="https://docs.google.com/document/d/1VxqO7kiQTHL7HpZMmxnQSF_dv_37u255u9eXgKIA-zU/edit#heading=h.nl8z9wpu7yj6">
                QuestAnalyzer
              </a>
              Google Doc, which is a work in progress.
              Click on the dashboard icon below to start counting.
            </p>
            <small>version 1.1</small>
          </div>
        </div>
      </md-card-content>
      <md-card-actions>
        <div v-if="!isLoggedIn">
          <md-button class="md-icon-button md-primary" to="dashboard">
            <md-icon>exit_to_app</md-icon>
          </md-button>
        </div>
        <div v-if="isLoggedIn">
          <md-button class="md-icon-button md-primary" to="dashboard">
            <md-icon>dashboard</md-icon>
          </md-button>
        </div>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>

export default {
  name: 'home',
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
};
</script>

<style lang="scss">
  .home {
    margin: 0 1rem;
    &.logged-out {
      padding-top: 1rem;
    }
  }
</style>
